import { createFileRoute } from '@tanstack/react-router';
import { DomainsTab } from '@/components/health-readiness/domains-tab';

/** Health & Readiness → Domains (T-0242): the first domain opens. */
export const Route = createFileRoute('/engagements/$engagementId/health-readiness/domains/')({
  component: DomainsIndexRoute,
});

function DomainsIndexRoute() {
  const { engagementId } = Route.useParams();
  return <DomainsTab engagementId={engagementId} />;
}
